import React from "react"
import styled from "styled-components"

import Header from "~/components/Header"
import HeaderLogoContainer from "./logos"
import MobileLogos from "./logos/mobileIndex"
import useFetcherLinks from "./useFetcherLinks"

const MainWrapper = styled.div`
  height: 100px;
  display: flex;
  flex-shrink: 0;
  align-items: center;
`

const FetcherHeader = ({ isMobile, noHamburger, fetcherType }) => {
  // Both desktop and mobile go through HeaderLogoContainer so the brand-domain
  // logo link (winitlaw.com on trafficviolation(s).info) is applied once.
  const MobileHeaderLogo = <HeaderLogoContainer fetcherType={fetcherType} />
  const HeaderLogo = <HeaderLogoContainer fetcherType={fetcherType} />
  const MobileMenuLogo = <MobileLogos />
  const showMobileSignUp = !isMobile
  const fetcherLinks = useFetcherLinks()

  return (
    <MainWrapper>
      <Header
        links={fetcherLinks}
        height="75px"
        headerLogo={HeaderLogo}
        mobileLogo={MobileHeaderLogo}
        mobileMenuBottomLogo={MobileMenuLogo}
        showMobileSignUp={showMobileSignUp}
        noHamburger={noHamburger}
      />
    </MainWrapper>
  )
}

export default FetcherHeader
